/**
 * GTC prompt is allowed when we can record acceptance for a client login.
 * Internal users must not see the modal, including after switching into a client account.
 * Do not gate on onboarding status (REGISTERED / ONBOARDING / ONBOARDED / …).
 * Signed vs unsigned is decided by approval-stats (current GTC version).
 */
export const canRequestGtcPrompt = (
  accountId: string,
  gtcType: string | null,
  isInternalUser = false,
): boolean => Boolean(accountId) && gtcType != null && !isInternalUser;
